import { PublicClass } from "./public.js"; 
import { getInfo, getToken } from "@/api/cookies";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
// 消息通知
class SocketIO {
  #io = {
    on: function (name, fn) {},
  };
  constructor() {}
  // 连接
  connect() {
    console.log(99999);
    
    const token = getToken();
    const user = getInfo();
    
    if (!token || !user) return;
    try {
      console.log(7777,process.env.VUE_APP_SOCKET_IO);
      
      this.#io = window.io.connect(process.env.VUE_APP_SOCKET_IO, {
        query: {
          token,
          userId: user.userId,
        },
        transports: ["websocket", "polling"],
      });
    } catch (error) {
      console.log(error,'error');
    }

    this.#io.on("connect", () => {
      console.log("io连接成功");
    });

    this.#io.on("connect_error", (error) => {
      console.log("io连接错误:", error);
    });

    this.#io.on("connect_timeout", (timeout) => {
      console.log("io连接超时:", timeout);
    });

    this.#io.on("error", (error) => {
      console.log("io发生错误:", error);
    });

    this.#io.on("disconnect", () => {
      console.log("io下线了");
    });

    this.#io.on("CHANNEL_STUDENT", (data) => {});

    this.#io.on("REMOTE_LANDING", (data) => {
      console.log("REMOTE_LANDING", data);

      // 强制下线
      if (data.code == 0) {
        window.location.href = "/";
        sessionStorage.setItem("offlineInfo", JSON.stringify(data.data));
         const DomainAuthorization = localStorage.getItem('DomainAuthorization');
              const domain = localStorage.getItem('domain');
              localStorage.clear();
              if (DomainAuthorization) localStorage.setItem('DomainAuthorization', DomainAuthorization);
              if (domain) localStorage.setItem('domain', domain);
        window.location.reload() 
      }
    });

    this.#io.on("ClientReceive", (data) => {
      const msg = JSON.stringify(data);
      console.log("io收到系统全局消息了：", msg);
    });
  }
}
export const socketIO = new SocketIO();

// 学习率上传
export class LearningRateIO extends PublicClass {
  #io = null; // io对象

  recordParsData = {}; // recordPars接口参数

  isLink = false; // 是否已连接
  isConnected = false; // 是否已连接过

  #heartbeatTimer = null; // 检测心跳定时器

  constructor(data) {
    super();

    if (data.recordPars) {
      this.recordParsData = data.recordPars;
      this.recordParsData.operateTypeCode = 1; // 1进入页面调用 2socketio链接成功调用
      this.recordParsData.clientTypeCode = 1; // 1PC 2M 3小程序 4Android 5IOS
      const userInfo = getInfo();
      this.recordParsData.userId = userInfo ? userInfo.userId : null;
      this.recordPars();
    }
  }

  // 进入播放页|打开SocketIo，记录参数和时间，解决用户没有记录学习率功能,记录观看记录相关数据，辅助查看用户反馈不记学习率问题
  recordPars() {
    /**
     * belongCourseTitleId: 课程名id
     * chapterId: 章id
     * classTypeId: 班型id
     * courseId: 课程id
     * nodeId: 节id
     * operateTypeCode: 1进入页面调用 2socketio链接成功调用
     * pageLocationTypeCode: 1近期直播进入观看直播中 2近期直播进入观看直播回放 3辅导班型进入观看直播中 4辅导班型进入观看直播回放 5辅导班型进入观看录播 6学习记录进入观看直播中 7学习记录观看直播回放 8学习记录观看录播回放
     * semesterId: 学期id
     * teachingMethod: 1直播 2录播
     * userId: 用户id
     */
    homeClient.recordPars(this.recordParsData);
  }

  // 连接
  connect(query) {
    console.log(process.env.VUE_APP_API_WebSocketUrl,'2222');
    
    if (!window.io) {
      console.error("socket.io client is not loaded");
      return;
    }
    
    this.#io = window.io.connect(process.env.VUE_APP_API_WebSocketUrl, { 
      query,
      transports: ["websocket", "polling"],
    });

    this.#watchOnline();

    this.#io.on("connect", () => {
      console.log("学习率IO-已连接");

      if (!this.isConnected) {
        // 只记录一次
        this.isConnected = true;
        this.recordParsData.operateTypeCode = 2; // 1进入页面调用 2socketio链接成功调用
        this.recordPars();
      }

      this.#connectSuccess();
    });

    this.#io.on("connect_error", () => {
      console.log("学习率IO-失败");
      this.isLink = false;
      super.$emit("onError");
    });

    this.#io.on("disconnect", () => {
      console.log("学习率IO-断开");
      this.isLink = false;
      super.$emit("onError");
    });

    this.#io.on("pong", () => {
      this.#heartbeat();
      super.$emit("pong");
    });

    // 小班课-学生进入看课通知
    this.#io.on("SMALL_COURSE_USER", (e) => {
      super.$emit("onPrivateMessage", JSON.parse(e));
    });

    // 学习率上传
    this.#io.on("SERVER_PING_SEND_CLIENT", (e) => {
      super.$emit("serverPingSend");
    });

    // 学习率返回
    this.#io.on("LEARNING_RATE_TOPIC", (e) => {
      super.$emit("learningRateTopic", JSON.parse(e));
    });
  }

  // 连接成功
  #connectSuccess() {
    this.#heartbeat();
    this.isLink = true;
    super.$emit("onOpen");
  }

  // 监听心跳
  #heartbeat() {
    this.#heartbeatTimer && clearTimeout(this.#heartbeatTimer);
    this.#heartbeatTimer = window.setTimeout(() => {
      console.log("hearbeat断开");
      super.$emit("onError");
    }, 30000);
  }

  // 监听网络连接状态
  #watchOnline() {
    this.#removeWatchOnline();
    window.addEventListener("online", this.#online.bind(this));
    window.addEventListener("offline", this.#offline.bind(this));
  }
  #removeWatchOnline() {
    window.removeEventListener("online", this.#online.bind(this));
    window.removeEventListener("offline", this.#offline.bind(this));
  }
  #online() {
    console.log("已连接至网络");

    this.#connectSuccess();
  }
  #offline() {
    console.log("未连接至网络");

    this.#heartbeatTimer && clearTimeout(this.#heartbeatTimer);

    super.$emit("onError");
  }

  // 发送消息
  send(data) {
    this.#io && this.#io.emit("ServerReceive", data);
  }

  // 学习率发送
  pingSendStudyRecord(data) {
    this.#io && this.#io.emit("pingSendStudyRecord", data);
  }

  // 主动断开连接
  close() {
    this.#io && this.#io.disconnect();
  }
}